import { render } from "./sim-hlr-info.vue?vue&type=template&id=fe83a114&scoped=true"
import script from "./sim-hlr-info.vue?vue&type=script&lang=js"
export * from "./sim-hlr-info.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-fe83a114"

export default script